import { render } from "./ProfileHeader.vue?vue&type=template&id=7fd36db6&scoped=true&ts=true"
import script from "./ProfileHeader.vue?vue&type=script&lang=ts"
export * from "./ProfileHeader.vue?vue&type=script&lang=ts"

import "./ProfileHeader.vue?vue&type=style&index=0&id=7fd36db6&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd36db6"]])

export default __exports__